module.exports = __webpack_public_path__ + "fonts/DM_Sans-700-latin15.7c87a64.woff2";